const Style = (theme) => ({
  w__100__field: {
    '& .control-width': {
      width: '100%',
    },
  },
});
export default Style;
